<template>
  <div>
    <JadeGroupHeader>{{ $t('title') }}</JadeGroupHeader>
    <JadeListItem
      :label="$t('provider-name')"
      :trailing="data.antifraud"
      compact
    />

    <JadeDivider />

    <JadeListItem
      :label="$t('score')"
      :trailing="data.score"
    />

    <JadeDivider />

    <div class="flex justify-between px-5 py-3">
      <JadeText>{{ $t('status') }}</JadeText>
      <JadeTag :variant="data.status.variant">
        {{ $t(`charge.filter.${data.status.text}`) }}
      </JadeTag>
    </div>

    <JadeDivider />

    <JadeListItem
      :label="$t('return-code')"
      :trailing="data.returnCode"
    />

    <JadeDivider />

    <div
      v-if="reprovedMessage"
      class="flex flex-col gap-2 px-5 py-5"
    >
      <JadeText
        color="negative"
        variant="text-medium"
        weight="semibold"
      >
        {{ $t('return-message-default') }}
      </JadeText>
      <JadeText
        color="negative"
        variant="text-medium"
      >
        {{ $t('return-message') }}
        <JadeText
          as="a"
          variant="hyperlink-medium"
          color="negative"
          alt="Help Center"
          :href="$sanitize(computedHelpLink)"
        >
          {{ $t('return-message-link') }}
        </JadeText>
      </JadeText>
    </div>
    <JadeDivider size="medium" />
  </div>
</template>

<script>
import {
  JadeTag,
  JadeGroupHeader,
  JadeText,
  JadeDivider,
  JadeListItem
} from '@jade'

export default {
  name: 'TransactionDetails',

  components: {
    JadeTag,
    JadeGroupHeader,
    JadeText,
    JadeDivider,
    JadeListItem
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
    computedHelpLink () {
      return process.env.VUE_APP_URL_HELP ?? ''
    },
    reprovedMessage () {
      return this.data.status.text === 'reproved'
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Dados do antifraude",
      "provider-name": "Antifraude",
      "status": "Status",
      "return-code": "Código de retorno",
      "return-message-default": "Esta cobrança foi avaliada como suspeita e, por segurança, não foi aprovada pelo Antifraude.",
      "return-message": "Entenda o que é possível fazer,",
      "return-message-link": "acessando a nossa Centra de Ajuda",
      "score": "Pontuação"
    },
    "en-US": {
      "title": "Antifraud data",
      "provider-name": "Anti fraud",
      "status": "Status",
      "return-code": "Return code",
      "return-message-default": "This charge was assessed as suspicious and, for security reasons, was not approved by Anti-Fraud.",
      "return-message": "Understand what you can do,",
      "return-message-link": "by accessing our Help Center",
      "score": "Score"
    }
  }
</i18n>
